export default "__VITE_ASSET__rNdEyaFU__"